import React from "react";
import { Image, Text, TouchableOpacity, View } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppImages } from "../../utility/AppImages";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import ShareComponent from "../ShareComponent";
import { useLiveStream } from "../../context/LiveStreamContext";

const LiveDetail = ({ styles }) => {
  const deviceSize = useDeviceSize();
  const { totalGiftedTokens, totalViewers, organizerData, viewerDetails } =
    useLiveStream();
  return (
    <View
      style={[
        styles.LiveView,
        {
          alignItems: "center",
        },
      ]}
    >
      <View
        style={[
          // styles.LiveView,
          {
            alignItems: "center",
            flexDirection: "row",
            flex: 1,
            gap:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 60
                : 0,
            justifyContent: "space-between",
          },
        ]}
      >
        <View style={{ flexDirection: "row" }}>
          <TouchableOpacity
            onPress={() => {}}
            style={{
              backgroundColor: AppColors.gray_757575,
              borderRadius: 8,
              height: 38,
              width: 38,
              marginVertical: 10,
              marginLeft: 5,
            }}
          >
            <Image
              source={AppImages.icCamera}
              resizeMode="contain"
              style={{
                height: 18,
                width: 20,
                alignSelf: "center",
                marginVertical: 8,
              }}
            />
          </TouchableOpacity>
          <TouchableOpacity
            style={{
              backgroundColor: AppColors.gray_757575,
              borderRadius: 8,
              height: 38,
              width: 38,
              margin: 10,
            }}
          >
            <Image
              source={AppImages.icVoice}
              resizeMode="contain"
              style={{
                height: 19,
                width: 14,
                alignSelf: "center",
                marginVertical: 8,
              }}
            />
          </TouchableOpacity>
        </View>
        <View>
          <Text style={[AppFontStyle.REGULAR_ANYBODY_12, { opacity: 0.5 }]}>
            Likes
          </Text>
          <Text style={[AppFontStyle.REGULAR_ANYBODY_16, { marginTop: 10 }]}>
            {organizerData?.likes ?? 0}
          </Text>
        </View>
        <View>
          <Text style={[AppFontStyle.REGULAR_ANYBODY_12, { opacity: 0.5 }]}>
            Total Viewers: {totalViewers ?? 0}
          </Text>
          <View
            style={{
              marginTop: 10,
              alignSelf: "center",
              flexDirection: "row",
            }}
          >
            {viewerDetails.length > 0 ? (
              [
                ...new Map(
                  viewerDetails.map((details) => [details.userId, details])
                ).values(),
              ]
                .slice(0, 10)
                .map((details: any, index: number) => (
                  <Image
                    key={details.userId}
                    source={{
                      uri: details.profilePicture ?? AppImages.Ellipse1,
                    }}
                    style={{
                      height: 19,
                      width: 19,
                      borderRadius: 100,
                      right: index * 12,
                    }}
                    resizeMode="contain"
                  />
                ))
            ) : (
              <Text style={{ color: "gray", fontSize: 14 }}>
                No live Viewers
              </Text>
            )}
          </View>
        </View>
      </View>

      <View
        style={[
          // styles.LiveView,
          {
            alignItems: "center",
            flexDirection: "row",
            flex: 0.8,
            gap:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 40
                : 0,
            justifyContent: "space-between",
          },
        ]}
      >
        {deviceSize === DEVICE_SIZES.XS ||
        deviceSize === DEVICE_SIZES.SM ? null : (
          <View
            style={{
              width: 1,
              backgroundColor: AppColors.white,
              opacity: 0.5,
              marginVertical: 7,
              height: 23,
            }}
          />
        )}
        <View>
          <Text style={[AppFontStyle.REGULAR_ANYBODY_12, { opacity: 0.5 }]}>
            Gifts received
          </Text>
        </View>
        <View>
          <View
            style={{
              flexDirection: "row",
              columnGap: 5,
              alignSelf: "center",
            }}
          >
            <Image
              source={AppImages.newGiftImg}
              style={{
                height: 24,
                width: 28,
              }}
              resizeMode="contain"
            />
            <Text
              style={[AppFontStyle.REGULAR_ANYBODY_16, { alignSelf: "center" }]}
            >
              {totalGiftedTokens ?? 0} tokens
            </Text>
          </View>
        </View>
        {deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM ? (
          <View>
            <ShareComponent
              accessToken={""}
              height={48}
              width={48}
              eventID={""}
            />
          </View>
        ) : null}
      </View>
    </View>
  );
};

export default LiveDetail;
